"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DEBUG = false;

try {
  config = require('../utils/get-config');
  DEBUG = config.DEBUG;
} catch (_) {}

var APIError = /*#__PURE__*/function (_Error) {
  _inherits(APIError, _Error);

  var _super = _createSuper(APIError);

  function APIError(message, options) {
    var _this;

    _classCallCheck(this, APIError);

    _this = _super.call(this, message, options);

    _defineProperty(_assertThisInitialized(_this), "statusCode", 500);

    if (options && options.cause && !_this.cause) {
      var cause = options.cause;
      _this.cause = cause;

      if (cause.stack) {
        _this.stack = "CAUSE: '".concat(cause.stack, "\n\n").concat(_this.stack);
      }
    }

    return _this;
  }

  _createClass(APIError, [{
    key: "getStatus",
    value: function getStatus() {
      var response = this.getAxiosResponse();

      if (response) {
        return response.status;
      }

      return this.status || this.statusCode;
    }
  }, {
    key: "__isAxiosError",
    value: function __isAxiosError() {
      return this.isAxiosError || this.cause && this.cause.isAxiosError;
    }
  }, {
    key: "getAxiosResponse",
    value: function getAxiosResponse() {
      if (!this.__isAxiosError()) {
        return;
      }

      if (this.cause && this.cause.response) {
        return this.cause.response;
      }

      if (this.response) {
        return this.response;
      }
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var response = this.getAxiosResponse();

      if (response) {
        var data = response.data,
            _config = response.config;
        return {
          data: data,
          status: this.getStatus(),
          stack: DEBUG ? this.stack : undefined,
          config: DEBUG ? _config : undefined
        };
      }

      return {
        status: this.getStatus(),
        message: this.message,
        stack: DEBUG ? this.stack : undefined
      };
    }
  }]);

  return APIError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var UnauthorizedError = /*#__PURE__*/function (_APIError) {
  _inherits(UnauthorizedError, _APIError);

  var _super2 = _createSuper(UnauthorizedError);

  function UnauthorizedError() {
    var _this2;

    _classCallCheck(this, UnauthorizedError);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this2), "name", 'UnauthorizedError');

    _defineProperty(_assertThisInitialized(_this2), "statusCode", 401);

    return _this2;
  }

  return UnauthorizedError;
}(APIError);

var ForbiddenError = /*#__PURE__*/function (_APIError2) {
  _inherits(ForbiddenError, _APIError2);

  var _super3 = _createSuper(ForbiddenError);

  function ForbiddenError() {
    var _this3;

    _classCallCheck(this, ForbiddenError);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this3 = _super3.call.apply(_super3, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this3), "name", 'ForbiddenError');

    _defineProperty(_assertThisInitialized(_this3), "statusCode", 403);

    return _this3;
  }

  return ForbiddenError;
}(APIError);

var DocumentNotFoundError = /*#__PURE__*/function (_APIError3) {
  _inherits(DocumentNotFoundError, _APIError3);

  var _super4 = _createSuper(DocumentNotFoundError);

  function DocumentNotFoundError() {
    var _this4;

    _classCallCheck(this, DocumentNotFoundError);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this4 = _super4.call.apply(_super4, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this4), "name", 'DocumentNotFoundError');

    _defineProperty(_assertThisInitialized(_this4), "statusCode", 404);

    return _this4;
  }

  return DocumentNotFoundError;
}(APIError);

var BadRequestError = /*#__PURE__*/function (_APIError4) {
  _inherits(BadRequestError, _APIError4);

  var _super5 = _createSuper(BadRequestError);

  function BadRequestError() {
    var _this5;

    _classCallCheck(this, BadRequestError);

    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    _this5 = _super5.call.apply(_super5, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this5), "name", 'BadRequestError');

    _defineProperty(_assertThisInitialized(_this5), "statusCode", 400);

    return _this5;
  }

  return BadRequestError;
}(APIError);

var RateLimitError = /*#__PURE__*/function (_APIError5) {
  _inherits(RateLimitError, _APIError5);

  var _super6 = _createSuper(RateLimitError);

  function RateLimitError() {
    var _this6;

    _classCallCheck(this, RateLimitError);

    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    _this6 = _super6.call.apply(_super6, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this6), "name", 'RateLimitError');

    _defineProperty(_assertThisInitialized(_this6), "statusCode", 429);

    return _this6;
  }

  return RateLimitError;
}(APIError);

module.exports = {
  APIError: APIError,
  UnauthorizedError: UnauthorizedError,
  ForbiddenError: ForbiddenError,
  DocumentNotFoundError: DocumentNotFoundError,
  BadRequestError: BadRequestError,
  RateLimitError: RateLimitError
};